import { forwardRef, useId } from 'react';
import cx from 'classnames';
import './Radio.css';

/**
 * QHS Radio v2
 * ------------
 *   <Radio name="g" value="f" checked={v==='f'} onChange={}>Female</Radio>
 */
const Radio = forwardRef(function Radio(
  { label, description, className, id, children, ...rest },
  ref
) {
  const autoId = useId();
  const inputId = id || autoId;
  return (
    <label htmlFor={inputId} className={cx('qhs-radio', className)}>
      <input ref={ref} id={inputId} type="radio" className="qhs-radio__input" {...rest} />
      <span className="qhs-radio__dot" aria-hidden="true" />
      {(label || children || description) && (
        <span className="qhs-radio__text">
          <span className="qhs-radio__label">{label || children}</span>
          {description && <span className="qhs-radio__desc">{description}</span>}
        </span>
      )}
    </label>
  );
});

export default Radio;
